import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import { Navigate } from 'react-router-dom';
import { PDFViewer } from '@react-pdf/renderer';
import ReactPDF, { Page, Text, View, Document, StyleSheet, Image, Font, PDFDownloadLink, Svg } from '@react-pdf/renderer';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import SelectHuntingClub, { components } from 'react-select';

import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import 'dayjs/locale/ru';
import 'dayjs/locale/de';

import { Form } from 'semantic-ui-react';

import axios from "axios";
import "./styles.css";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  InputLabel,
  FormControl,
  Select,
  TextField
  
} from '@mui/material';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import ClanProfil from '../pages/ClanProfil';
import HunterReport from './HunterReport';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'ime', label: 'Ime', alignRight: false },
  { id: 'prezime', label: 'Prezime', alignRight: false },
  { id: 'adresa', label: 'Adresa', alignRight: false },
  { id: 'telefon', label: 'Telefon', alignRight: false },
  { id: 'huntingclubId', label: 'Lovačko društvo', alignRight: false },
  { id: 'maticnibrojlovca', label: 'Matični broj', alignRight: false },
  { id: 'datumpolaganja', label: 'Lovački ispit', alignRight: false },
  { id: 'vrstaclanstva', label: 'Vrsta članstva', alignRight: false },
  { id: 'lovackilist', label: 'Lovački list', alignRight: false },
  { id: 'uvjerenje', label: 'Uvjerenje', alignRight: false }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, field) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
	if (field === 'ime')
    return filter(array, (_user) => _user.ime.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'prezime')
    return filter(array, (_user) => _user.prezime.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'maticnibrojlovca')
    return filter(array, (_user) => _user.maticnibrojlovca.indexOf(query) !== -1);

	if (field === 'adresa')
    return filter(array, (_user) => _user.adresa.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'telefon')
    return filter(array, (_user) => _user.telefon.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'huntingclubId')   
    return filter(array, (_user) => _user.huntingclub.naziv.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'datumpolaganja')
    return filter(array, (_user) => _user.datumpolaganja.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'vrstaclanstva')
    return filter(array, (_user) => _user.vrstaclanstva.toLowerCase().indexOf(query.toLowerCase()) !== -1);

	if (field === 'lovackilist')
    return filter(array, (_user) => _user.lovackilist.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function HunterForPunishment(props) {
	
  const [value, setValue] = useState('');
	
  const [punishmenttypeId, setPunishmentTypeId] = useState('1');
  
  const [punishmenthunterid, setPunishmentHunterId] = useState('');

  const [huntingclub, setHuntingClub] = useState('');
	
  const [loading, setLoading] = useState(false);
	
  const [showreport, setShowReport] = useState(false);

  const [id, setId] = useState('');
	
  const [open, setOpen] = useState(false);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');
  
  const [members, setMembers] = useState([]);
  
  const [hunter, setHunter] = useState('');
  
  const [izabran, setIzabran] = useState('');
  
  const [dataloaded, setDataLoaded] = useState(false);

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('id');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);
  
  const { user: currentUser } = useSelector((state) => state.auth);
  
  const [datumdodjele, setDatumDodjele] = useState('');
  
  const [opis, setOpis] = useState('');
  
  const [napomena, setNapomena] = useState('');	
 
  const [selectedOption, setSelectedOption] = useState(null);
 
 
 
  const handleChange = (event) => {
	console.log(event.target.value);
    setPunishmentTypeId(event.target.value);
  }; 
  
  const handleChange1 = e => {
    setSelectedOption(e);
  }
  
  const handleChangeHuntingClub = e => {
    setSelectedOption(e);
    console.log(e);
	setPunishmentTypeId(e.value);
  }
  
  const handleClose = () => {
    setOpen(false);
  };

  const handleNo = () => {
    setOpen(false);
  };
  
  const handleYes = () => {
	console.log(datumdodjele);
    axios.post(`http://89.46.196.228:3000/api/punishments`,
		{
			"hunterId": props.hunterId,
			"punishmenttypeId": punishmenttypeId,
			"datum": datumdodjele,
			"opis": opis,
			"napomena": napomena
		}
		).then(() => {
				//getAllTickets();
				props.handler();
            // navigate('/dashboard/app')
		});
		
    setOpen(false);
  };
  
  useEffect(() => {
	if (!dataloaded) {
    getAllTickets();
	console.log(currentUser.roles[0]);
    const role = currentUser.roles[0];
    const rolenumber = role.slice(10);
   
    console.log(rolenumber);
	getHuntingClub(rolenumber);
	}
  }, []);
  
  const getAllTickets = async () => {
      try {
        const response = await axios.get("http://89.46.196.228:3000/api/hunters?limit=17250");
        setMembers(response.data);
		setDataLoaded(true);
		console.log(response.data);
		getAllHunters();
      } catch (err) {
        console.log("error");
      }
    };
  
  const getAllHunters = async () => {
      try {
        const response = await axios.get("http://89.46.196.228:3000/api/hunters");
        setMembers(response.data);
		setDataLoaded(true);
		console.log(response.data);
      } catch (err) {
        console.log("error");
      }
  };
    
  const getHuntingClub = async (huntingclubid) => {
      try {
		console.log(huntingclubid);  
        const response = await axios.get("http://89.46.196.228:3000/api/huntingclubs/" + huntingclubid);
        setHuntingClub(response.data);
		console.log(response.data);
      } catch (err) {
        console.log("error");
      }
  };
  
  const getHunter = async (hunterid) => {
      try {
        const response = await axios.get("http://89.46.196.228:3000/api/hunters/" + hunterid);
		// setId(izabran);
        setHunter(response.data);
		// setDataLoaded(true);
		setShowReport(!showreport);
		console.log(response.data);
      } catch (err) {
        console.log("error");
      }
  };
  
  // if (id !== izabran)
   //  getHunter();
	
  console.log(currentUser);

  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  const setData = (data) => {
  console.log(data);
  
  const { id, maticnibrojlovca, ime, prezime, adresa, telefon, lovackodrustvo, datumpolaganja, vrstaclanstva, photo, lovackilist } = data;
  
  console.log(id);
  console.log(adresa);
  
  localStorage.setItem('id', id);
  localStorage.setItem('maticnibrojlovca', maticnibrojlovca);
  localStorage.setItem('ime', ime);  
  localStorage.setItem('prezime', prezime);
  localStorage.setItem('adresa', adresa);
  localStorage.setItem('telefon', telefon);
  localStorage.setItem('lovackodrustvo', lovackodrustvo);
  localStorage.setItem('datumpolaganja', datumpolaganja);
  localStorage.setItem('vrstaclanstva', vrstaclanstva);
  localStorage.setItem('photo', photo);
  localStorage.setItem('lovackilist', lovackilist);
  
  }
  
  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
	console.log(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = members.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
	  
	console.log(id);	
	
	setPunishmentHunterId(id);
	
	setOpen(true);

  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - members.length) : 0;

  const filteredUsers = applySortFilter(members, getComparator(order, orderBy), filterName, orderBy);

  const isNotFound = !filteredUsers.length && !!filterName;
  
  var today = new Date();

  const datum ='Datum: ' +  today.getDate()  + '.' + (today.getMonth() + 1) + '.' + today.getFullYear() + '. god.';

Font.register({
  family: "Roboto",
  src:
    "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf"
});

const styles = StyleSheet.create({
  page: {
    fontFamily: "Roboto"
  },
  body: {
    paddingTop: 50,
    paddingBottom: 65,
    paddingHorizontal: 30,
	fontFamily: "Roboto", 
	fontSize: 10,
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    fontFamily: 'Roboto'
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: 'Roboto'
  },
  text: {
    margin: 5,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmedium: {
    margin: 3,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmediumlarge: {
    margin: 12,
    fontSize: 20,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  textbig: {
    margin: 12,
    fontSize: 28,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  selectimage: {
    margin: 0,
	paddingTop : 0,
	padding : 0,
	height: 40,
	paddingHorizontal: 10,
  },
  selecttext: {
    margin: 3,
    fontSize: 16,
    textAlign: 'justify',
	paddingHorizontal: 20,
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  officer: {
	paddingTop: 70,
    fontSize: 12,
	margin: 0,
    fontSize: 12,
    fontFamily: 'Roboto',
	left: 150,
  },
  officertext: {
    margin: 0,
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'Roboto',
  },
  mp: {
    position: 'absolute',
    fontSize: 12,
    bottom: 100,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey'
  },
  table: { 
    display: "table", 
    width: "auto", 
    borderStyle: "solid",  
    borderRightWidth: 0, 
	borderLefttWidth: 0, 
    borderTopWidth: 0,
	borderBottomWidth: 0,
  }, 
  tableRow: { 
    margin: "0", 
    flexDirection: "row",
	 borderWidth: 0,
  }, 
  tableCol: { 
    width: "20%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  }, 
  tableColLong: { 
    width: "30%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableColShort: { 
    width: "15%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableColVeryShort: { 
    width: "5%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableCell: { 
    margin: "auto", 
    marginTop: 5, 
    fontSize: 10 
  },
});

const customStyles = {
  control: base => ({
    ...base,
	width: 220,
    height: 55,
    minHeight: 35,
	fontSize: 16,
  })
};
  
  const options = [
	{ value: "1", label: "Ukor 1", icon: "/assets/images/kazne/photo_1.jpg" },
	{ value: "2", label: "Ukor 2", icon: "/assets/images/kazne/photo_2.jpg" },
	{ value: "3", label: "Ukor 3", icon: "/assets/images/kazne/photo_3.jpg" },
	{ value: "4", label: "Ukor 4", icon: "/assets/images/kazne/photo_4.jpg" },
	{ value: "5", label: "Ukor 5", icon: "/assets/images/kazne/photo_5.jpg" }
	];

	const { Option } = components;
	const IconOption = props => (
	<Option {...props}>
	<TableRow style={styles.selectimage}>
	
	<TableCell style={styles.selectimage} align="left">
	
	    <Stack direction="row" alignItems="center" spacing={2}>
		
            <Avatar alt={props.data.label} src={props.data.icon} />
							
			<Typography style={styles.textmedium} variant="subtitle2" noWrap>
				
			</Typography>
			
        </Stack>
						  
	</TableCell>
	
	<TableCell style={styles.selectimage} align="left">
	<Typography style={styles.selecttext} variant="subtitle2" noWrap>
	{props.data.label}
	</Typography>
	</TableCell>
							
	</TableRow>
	</Option>
	);

  return (
    <>
      <Helmet>
        <title>  Savez lovačkih organizacija u BiH </title>
      </Helmet>
	  
	  <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Dodavanje nove disciplinske mjere 
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Da li ste sigurni?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleNo}>Ne</Button>
          <Button onClick={handleYes} autoFocus>Da</Button>
        </DialogActions>
      </Dialog>
	  		
	  <Container maxWidth="xl">
	  	<Typography variant="subtitle2" noWrap>
			Nova disciplinska mjera
		</Typography>
        <Card>
          <Scrollbar>
		  
		    <TableContainer sx={{ minWidth: 800 }}>
			
              <Table style={{ tableLayout: 'fixed'}}>
			  
                <TableBody>
        
                <TableRow>

					<TableCell component="th" scope="row" >
						<FormControl>
							<SelectHuntingClub 
							menuPortalTarget={document.body} 
							menuPosition={'fixed'}
							defaultValue={options[0]}
							options={options}
							components={{ Option: IconOption }}
							onChange={handleChangeHuntingClub}
							styles={customStyles}
						    />
						</FormControl>
					</TableCell>
					
					<TableCell component="th" scope="row" >
						<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
							<DatePicker
								label="Datum izricanja"
								value={value}
								onChange={(newValue) => {
								setValue(newValue);
								const datum = newValue.$D + '.' + (newValue.$m + 1) + '.' + newValue.$y + '.';
								console.log(datum);
								setDatumDodjele(datum);
								}}
								renderInput={(params) => <TextField {...params} />}
							/>
						</LocalizationProvider>
                    </TableCell>
							
					<TableCell component="th" scope="row" >
						<TextField
							required
							id="outlined-required"
							label="Opis"
							defaultValue=""
							onChange={(e) => setOpis(e.target.value)}
						/>
                    </TableCell>
					
					<TableCell component="th" scope="row" >
						<TextField
							required
							id="outlined-required"
							label="Napomena"
							defaultValue=""
							onChange={(e) => setNapomena(e.target.value)}
						/>
                    </TableCell>
						
                </TableRow>
				
				<TableRow>
				<Button onClick={() => setOpen(true)}>Spasi</Button>
				</TableRow>
				
                </TableBody>
				
              </Table>
			  
            </TableContainer>
			
          </Scrollbar>

        </Card>
		
      </Container>
	  
    </>
  );
}
